<template>
  <vue-final-modal
    v-slot="{ close }"
    v-bind="$attrs"
    classes="facilities-vfm-overlay"
    content-class="facilities-vfm-content"
    :esc-to-close="true"
    :click-to-close="true"
  >
    <div class="facilities-dialog">
      <header class="facilities-dialog-head">
        <div class="facilities-dialog-icon">
          <i class="fa-solid fa-warehouse"></i>
        </div>
        <div class="facilities-dialog-copy">
          <h2>Objektet e magazinës</h2>
          <p>Shihni tipet e objekteve, shtoni një të ri, ose ndryshoni emrin ekzistues.</p>
        </div>
        <button type="button" class="facilities-dialog-close" title="Mbyll" @click="close">
          <i class="fas fa-times"></i>
        </button>
      </header>
      <div class="facilities-dialog-body">
        <facilities-grid></facilities-grid>
      </div>
    </div>
  </vue-final-modal>
</template>

<script>
import { VueFinalModal } from "vue-final-modal";
import FacilitiesGrid from "./facilities-grid.vue";

export default {
  components: {
    VueFinalModal,
    FacilitiesGrid,
  },
};
</script>

<style>
.facilities-vfm-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 6vh 16px 32px;
  overflow: auto;
  background: rgba(15, 23, 42, 0.45);
}
.facilities-vfm-content {
  position: relative;
  width: 100%;
  max-width: 680px;
  margin: 0;
  padding: 0;
  border: 0;
  background: transparent;
  box-shadow: none;
}
.facilities-dialog {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.18);
  overflow: hidden;
}
.facilities-dialog-head {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 18px 18px 14px;
  border-bottom: 1px solid #eef2f7;
  background: linear-gradient(180deg, #f8fbff 0%, #ffffff 100%);
}
.facilities-dialog-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 12px;
  background: #eff6ff;
  color: #1d4ed8;
  font-size: 18px;
  flex-shrink: 0;
}
.facilities-dialog-copy {
  min-width: 0;
  flex: 1;
}
.facilities-dialog-copy h2 {
  margin: 0 0 4px;
  font-size: 18px;
  font-weight: 700;
  color: #0f172a;
}
.facilities-dialog-copy p {
  margin: 0;
  font-size: 13px;
  line-height: 1.45;
  color: #64748b;
}
.facilities-dialog-close {
  border: 0;
  background: transparent;
  color: #64748b;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  cursor: pointer;
  flex-shrink: 0;
}
.facilities-dialog-close:hover {
  background: #f1f5f9;
  color: #0f172a;
}
.facilities-dialog-body {
  padding: 14px 16px 16px;
}
</style>
